import axios from "@/plugins/axios";
// import * as example from "./example";

let url = "/api/v1/me/shop/gift-orders";

export const giftOrders = {
    // ...example,
    gets(data){
        return axios.get(url, data).then(result => result.data);
    },
    get(data){
        return axios.get(`${url}/${data._id}`).then(result => result.data);
    },
    put(data){
        return axios.put(`${url}/${data._id}`, data).then(result => result.data);
    },
}
